/* ==========================================================================
   RACEM  |  racem.js
   Jediny subor s vlastnym JS pre celu temu.
   Obsah: cookie lista, uvitaci popup, karusel akciovych produktov.
   Ziadny inline JS v theme.liquid.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- pomocne ---------- */

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }

  /* Trvaly priznak "popup uz videl" ukladame naraz do localStorage aj do cookie.
     Na mobilnych in-app prehliadacoch (Instagram, Facebook) a v anonymnom rezime
     byva localStorage casto zablokovany alebo izolovany. Bez cookie by sa priznak
     nikdy neulozil, popup by sa otvaral znova na kazdej stranke a zakazdym by
     zamkol scroll. Prave toto sposobovalo, ze sa na mobiloch a tabletoch nedalo
     scrollovat. */
  function markPopupSeen() {
    store('racem_offer_popup_seen', 'true');
    setCookie('racem_offer_popup_seen', 'true', 365);
  }

  function popupSeen() {
    return store('racem_offer_popup_seen') === 'true' || getCookie('racem_offer_popup_seen') === 'true';
  }

  /* Bezpecne zamykanie a odomykanie scrollu tela stranky. */
  function lockScroll() {
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
  }

  /* ---------- 1. cookie lista ---------- */

  function initCookieBanner() {
    var banner = document.getElementById('racem-cookie');
    if (!banner) return;

    var accept = banner.querySelector('[data-rc-cookie-accept]');
    var decline = banner.querySelector('[data-rc-cookie-decline]');

    function answer(value) {
      setCookie('racem_cookie', value, 365);
      banner.classList.remove('show');

      /* Napojenie na Shopify Customer Privacy API.
         Bez tohto je lista iba obrazok a pixely bezia tak ci tak. */
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: value === 'accepted',
            marketing: value === 'accepted',
            preferences: value === 'accepted',
            sale_of_data: value === 'accepted',
          },
          function () {}
        );
      }
    }

    if (accept) accept.addEventListener('click', function () { answer('accepted'); });
    if (decline) decline.addEventListener('click', function () { answer('declined'); });

    if (!getCookie('racem_cookie')) {
      window.setTimeout(function () { banner.classList.add('show'); }, 800);
    }
  }

  /* ---------- 2. uvitaci popup ---------- */

  function initOfferPopup() {
    var popup = document.getElementById('racemOfferPopup');
    if (!popup) return;

    /* Poistka pri nacitani stranky: ak z akehokolvek predchadzajuceho stavu
       zostal zamknuty scroll a popup nie je viditelny, hned ho odomkni. */
    if (!popup.classList.contains('show')) unlockScroll();

    var delay = parseInt(popup.dataset.delay || '6', 10) * 1000;
    var lastFocused = null;

    function open() {
      /* Dvojita poistka, aby sa popup neotvoril, ak uz bol videny. */
      if (popupSeen()) return;
      lastFocused = document.activeElement;
      popup.classList.add('show');
      popup.setAttribute('aria-hidden', 'false');
      lockScroll();
      var input = popup.querySelector('input[type="email"]');
      if (input) input.focus();
    }

    function close() {
      popup.classList.remove('show');
      popup.setAttribute('aria-hidden', 'true');
      unlockScroll();
      markPopupSeen();
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    popup.querySelectorAll('[data-rc-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('show')) close();
    });

    var form = popup.querySelector('[data-rc-popup-form]');
    var input = popup.querySelector('input[type="email"]');
    var button = popup.querySelector('[data-rc-popup-submit]');
    var errorBox = popup.querySelector('[data-rc-popup-error]');
    var successBox = popup.querySelector('[data-rc-popup-success]');
    var codeBox = popup.querySelector('[data-rc-popup-code]');

    if (button && input) {
      button.addEventListener('click', function () {
        if (!input.value || !input.checkValidity()) {
          if (errorBox) errorBox.classList.add('show');
          return;
        }
        if (errorBox) errorBox.classList.remove('show');

        var original = button.textContent;
        button.disabled = true;
        button.textContent = button.dataset.loading || original;

        var data = new FormData();
        data.append('form_type', 'customer');
        data.append('utf8', '\u2713');
        data.append('contact[email]', input.value);
        data.append('contact[tags]', 'newsletter,discount-popup');
        data.append('customer[accepts_marketing]', 'true');

        fetch('/contact', { method: 'POST', body: data })
          .then(function () {
            markPopupSeen();
            if (form) form.style.display = 'none';
            if (successBox) {
              /* Kod sa do stranky dostane az teraz, nie hned pri nacitani. */
              if (codeBox && codeBox.dataset.code) codeBox.textContent = codeBox.dataset.code;
              successBox.classList.add('show');
            }
          })
          .catch(function () {
            if (errorBox) {
              errorBox.textContent = errorBox.dataset.fail || errorBox.textContent;
              errorBox.classList.add('show');
            }
            button.disabled = false;
            button.textContent = original;
          });
      });
    }

    if (codeBox) {
      codeBox.addEventListener('click', function () {
        var code = codeBox.dataset.code;
        if (!code || !navigator.clipboard) return;
        navigator.clipboard.writeText(code).then(function () {
          var previous = codeBox.textContent;
          codeBox.textContent = codeBox.dataset.copied || previous;
          window.setTimeout(function () { codeBox.textContent = previous; }, 1600);
        });
      });
    }

    if (!popupSeen() && !(window.Shopify && window.Shopify.designMode)) {
      window.setTimeout(open, delay);
    }
  }

  /* ---------- 3. karusel akciovych produktov ---------- */

  function initSaleCarousel() {
    var track = document.getElementById('rcSaleTrack');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.rc-deal'));
    items.sort(function (a, b) {
      var byDiscount = parseFloat(b.dataset.discount || 0) - parseFloat(a.dataset.discount || 0);
      return byDiscount !== 0 ? byDiscount : parseFloat(b.dataset.saved || 0) - parseFloat(a.dataset.saved || 0);
    });
    items.forEach(function (item) { track.appendChild(item); });

    var viewport = track.closest('.rc-sale__viewport');
    if (!viewport) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !window.matchMedia('(min-width: 641px)').matches) return;

    var direction = 1;
    var speed = 0.3;
    var paused = false;
    var frame;

    function step() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 0) return;
      if (!paused) viewport.scrollLeft += speed * direction;
      if (viewport.scrollLeft >= max - 1) direction = -1;
      if (viewport.scrollLeft <= 1) direction = 1;
      frame = window.requestAnimationFrame(step);
    }

    viewport.addEventListener('mouseenter', function () { paused = true; });
    viewport.addEventListener('mouseleave', function () { paused = false; });
    viewport.addEventListener('focusin', function () { paused = true; });

    /* Beh iba ked je sekcia na obrazovke, inak zbytocne zerie vykon. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            frame = window.requestAnimationFrame(step);
          } else {
            window.cancelAnimationFrame(frame);
          }
        });
      }).observe(viewport);
    } else {
      frame = window.requestAnimationFrame(step);
    }
  }

  /* ---------- start ---------- */

  function init() {
    initCookieBanner();
    initOfferPopup();
    initSaleCarousel();
  }

  /* Globalna poistka proti zaseknutemu scrollu.
     Ked sa stranka obnovi z bfcache (tlacidlo spat na mobile) alebo sa vrati na
     kartu, telo nesmie zostat zamknute, ak popup prave nie je viditelny. */
  window.addEventListener('pageshow', function () {
    var popup = document.getElementById('racemOfferPopup');
    if (!popup || !popup.classList.contains('show')) {
      document.body.style.overflow = '';
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();